// 用户
/**
 * 登陆
 * @returns {Promise<Record<string, any>} 登陆结果
 */
export function loginIn() {
  return new Promise((resolve) => {
    const { _tc_bridge_user } = window
    if (_tc_bridge_user) {
      _tc_bridge_user.user_login({
        params: {},
        callback(data) {
          data = JSON.parse(data.CBData)
          resolve(data)
        }
      })
    }
  })
}
/**
 * 获取app会员id
 * @returns {Promise<string>} 返回memeberid， 获取失败为空
 */
export function getMemberId() {
  return new Promise((res, rej) => {
    console.log(window._tc_bridge_user)
    if (window._tc_bridge_user) {
      console.log('getMemberId', window._tc_bridge_user)
      window._tc_bridge_user.get_device_info({
        param: {
          abIds: ["key1", "key2"],
          requestPermission: "1"
        },
        callback(data) {
          console.log('获取数据', data)
          console.log(data.CBData)
          const { memberInfo } = JSON.parse(data.CBData)
          console.log(memberInfo)
          res(memberInfo)
        }
      })
    } else {
      res("")
    }
  })
}